import Pledge from './pledge'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { CROWD_FUNDING } from 'shared/shared_consts'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const isCrowdfunding = campaign.campaign_type === CROWD_FUNDING

  return {
    currency: campaign.currency,
    maxAmount: campaign.max_amount,
    campaignType: campaign.campaign_type,
    initialValues: {
      pledge: campaign.pledge || 0,
    },
    minAmount: state.flags.min_amount_donation,
    isCrowdfunding: isCrowdfunding,
    campaignTitle: campaign.title,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onPledge(fields) {
      return dispatch(
        updateRemotely(campaignId, { pledge: fields.pledge || 0 })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'pledge',
    fields: ['pledge'],
    destroyOnUnmount: false,
    touchOnChange: false,
    touchOnBlur: true,
  },
  mapStateToProps,
  mapDispatchToProps
)(Pledge)
